export const ROUTE_TARGETS = {
  lanternal: 'lanternal',
  content: 'content',
  both: 'both',
};

export const normalizeTargetApp = (target) => {
  const normalized = (target || ROUTE_TARGETS.lanternal).toLowerCase();
  if (normalized === ROUTE_TARGETS.content) {
    return ROUTE_TARGETS.content;
  }
  if (normalized === ROUTE_TARGETS.both) {
    return ROUTE_TARGETS.lanternal;
  }
  return ROUTE_TARGETS.lanternal;
};

export const isContentTarget = (target) => normalizeTargetApp(target) === ROUTE_TARGETS.content;

export const getContentBaseUrl = () => {
  const hostname = window?.location?.hostname;

  // Lanternal Production -> Lantern Production
  if (hostname === 'lanternal.harvestgroup.com' || hostname === 'lanternalprodstorage.z13.web.core.windows.net') {
    return 'https://lantern.harvestgroup.com';
  }

  // Lanternal Test -> Lantern Test
  if (hostname === 'lanternal-test.harvestgroup.com' || hostname === 'lanternaltestsstorage.z13.web.core.windows.net') {
    return 'https://lantern-test.harvestgroup.com';
  }

  // Local development
  if (hostname === 'localhost') {
    return 'http://localhost:3000';
  }

  // Fallback to environment variable if set
  return process.env.REACT_APP_CONTENT_BASE_URL || '';
};

export const buildExternalUrl = (baseUrl, path) => {
  if (!baseUrl) {
    return path || '/';
  }

  const normalizedBase = baseUrl.replace(/\/+$/g, '');
  const normalizedPath = path ? path.replace(/^\/+/, '') : '';

  if (!normalizedPath) {
    return normalizedBase;
  }

  return `${normalizedBase}/${normalizedPath}`;
};
